const fs = require('fs').promises;
const path = require('path');

exports.replaceColorsWithSmetioDataAttributesInSvg = async (data = {
    imagePath: "../../../../production/img/appImages/SVG/",
    imageName: "personalDetails_test",
}) => {

    const { imagePath, imageName } = data;
    const colors = {
        dominant: ["#102040", "#0f203f"],
        accent: ["#96b3d9"],
        warning: ["#dfc08b"],
        neutral: ["#e9eff7"]
    };

    // const imagePath = "../../../../production/img/appImages/SVG/";
    // const imageName = "personalDetails_test";

    const image = `${imagePath}${imageName}.svg`;

    let newContent = await fs.readFile(path.resolve(__dirname, image), 'utf8');

    // let newContent = data;

    for (const key in colors) {

        const colorArr = colors[key];

        for (let i = 0; i < colorArr.length; i++) {
            const colorCode = colorArr[i];
            let replaceFill = `fill="${colorCode}"`;
            replaceFill = new RegExp(replaceFill, "g");

            let replaceStroke = `stroke="${colorCode}"`;
            replaceStroke = new RegExp(replaceStroke, "g");

            newContent = newContent.replaceAll(replaceFill, `data-smetio-${key}-fill=true`);
            newContent = newContent.replaceAll(replaceStroke, `data-smetio-${key}-stroke=true`);
        };

    };

    const jsFile = `${imagePath}${imageName}.js`
    const jsFileContent = `
        export default function ${imageName}() {
            
            return\`
                ${newContent}
            \`;
        }
    `;

    const txtFile = `${imagePath}${imageName}.txt`;
    const txtContent = newContent;

    // fs.writeFile(path.resolve(__dirname, jsFile), jsFileContent, function (err) {
    //     if (err) throw err;
    //     console.log('js file created');
    // });

    fs.writeFile(path.resolve(__dirname, txtFile), txtContent, function (err) {
        if (err) throw err;
        console.log('txt file created');
    });

};
